(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              recommendationSlider();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  // Function to reinitialize Owl Carousel
  function recommendationSlider() {
    var rtlFlag = $('body').hasClass('lang-rtl') ? true : false;
    $('.slider-mobile-gutter .owl-carousel').owlCarousel({
      loop: false,
       nav: true,
       center: false,
       autoplay: false,
       dots: false,
       navText: ["<svg xmlns='http://www.w3.org/2000/svg' width='11.785' height='20' viewBox='0 0 11.785 20'><defs><style>.a{fill:#000;}</style></defs><path class='a' d='M19.679,23.353l-6.944-6.944,6.944-6.944a1.784,1.784,0,1,0-2.523-2.523L8.941,15.156a1.782,1.782,0,0,0,0,2.523l8.215,8.215a1.782,1.782,0,0,0,2.523,0,1.821,1.821,0,0,0,0-2.541Z' transform='translate(-8.417 -6.417)'></path></svg>","<svg xmlns='http://www.w3.org/2000/svg' width='11.785' height='20' viewBox='0 0 11.785 20'><defs><style>.a{fill:#000;}</style></defs><path class='a' d='M19.679,23.353l-6.944-6.944,6.944-6.944a1.784,1.784,0,1,0-2.523-2.523L8.941,15.156a1.782,1.782,0,0,0,0,2.523l8.215,8.215a1.782,1.782,0,0,0,2.523,0,1.821,1.821,0,0,0,0-2.541Z' transform='translate(-8.417 -6.417)'></path></svg>"],
       rtl:rtlFlag,
       rewind: false,
       responsive:{
         0:{
           items:2
         },
         544:{
           items:2,
           margin:30
         },
         992:{
           items:6,
           margin:20
         },
         1200:{
           items:6,
           margin:30
         },
         1400:{
           items:6,
           margin:30
         }
       }
    });
  }
  
  $(document).ready(function () {
    recommendationSlider();
  });
  

  } catch(e) { console.error(e); }
})();
})();
